import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000 * 1,     // cache fresh for 1 min
      refetchOnWindowFocus: false,  // no surprise refetches while typing
      retry: 2,                     // retry reads up to 2 times
    },
    mutations: {
      retry: 0,                     // never auto-retry writes
    },
  },
});